import React from 'react'
import styled from 'styled-components'
import { Heading, Card, CardBody, Text } from '@pancakeswap-libs/uikit'
import useI18n from 'hooks/useI18n'
import { useTotalValue } from '../../../state/hooks'
import CardValue from './CardValue'

const StyledTotalValueLockedCard = styled(Card)`
  align-items: center;
  display: flex;
  justify-content: start;
  flex: 1;
  background-image: url('/images/home_tvl_img.png');
  background-repeat: no-repeat;
  background-position: right -30px bottom -30px;
`
const HeadingWithoutColor = styled(Card)`
  font-size: 24px
`

const TotalValueLockedCard = () => {
  const TranslateString = useI18n()
   const totalValue = useTotalValue();
  // const tvl = totalValue.toFixed(2);

  return (
    <StyledTotalValueLockedCard className="white_box home_total_box">
      <CardBody>
          <Text as="h3" color="textSubtle" mb="5px">
            Total Value Locked (TVL)
          </Text>
        <>
          <Heading as="h2">
            <CardValue color="secondary" size="xl" value={totalValue.toNumber()} prefix="$" decimals={0}/>
          </Heading>
          {/* <Heading size="xl"> */}
          {/* </Heading> */}
          <Text as="h5" color="textSubtle" mt="5px">{TranslateString(999, 'Across all Farms and Pools')}</Text>
        </>
      </CardBody>
    </StyledTotalValueLockedCard>
  )
}

export default TotalValueLockedCard
